import { IdOutskirtBuildings } from "../../../../constants/IdOutskirtBuildings";
export var checkIsOutskirtBuildingLibrary = function (path) { return function (action, state$, dependencies) {
    var isOutskirtBuildingLibrary = action.taskType &&
        action.taskType.outsideBuildingId &&
        action.taskType.outsideBuildingId === IdOutskirtBuildings.Library;
    return isOutskirtBuildingLibrary ? path : undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/quest-tasks/buy-improvement/checkIsOutskirtBuildingLibrary.ts
// module id = 2352
// module chunks = 3